import { ReactComponent as PlayStoreIcon} from '../assets/google-playstore.svg';

export const googlePlayDeveloperLink = 'https://play.google.com/store/apps/dev?id=7276213906278201532';

export const socialMedia = [
  {
    link: googlePlayDeveloperLink,
    Icon: <PlayStoreIcon />
  }
]; 